<template>
  <div>
    <span ref="signinBtn" class="invisible" />
    <a
      href="#social-login"
      title="Login with Google"
      :class="{ visible: termsAgreed || formType === 'login' }"
    >
      <IconGoogle /> Google
    </a>
    <a
      href="#social-login"
      title="Sign up with Google"
      class="fake"
      :class="{ visible: !termsAgreed && formType === 'signup' }"
      @click.prevent="checkTerms"
    >
      <IconGoogle /> Google
    </a>
  </div>
</template>
<script>
import IconGoogle from '../../assets/svg/icon-colored-google.svg?vue-component';

export default {
  components: { IconGoogle },
  props: {
    keepMeLoggedIn: Boolean,
    errored: Boolean,
    campaign: Boolean,
    termsAgreed: Boolean,
    formType: { type: String, default: '' },
  },
  async mounted() {
    await this.$pollValue(() => typeof window.google !== 'undefined');
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: this.$config.googleApiKey,
        callback: this.handleCredentialResponse,
      });
      // window.google.accounts.id.prompt();
      window.google.accounts.id.renderButton(this.$refs.signinBtn, {});
    }
  },
  methods: {
    checkTerms() {
      this.$root.$emit('check-terms', true);
    },
    async handleCredentialResponse(response) {
      if (this.formType === 'signup') {
        this.checkTerms();
      }
      const token = response.credential;
      await this.$root.$emit('check');
      if (!this.errored) {
        const request = await this.$axios.$post(`/auth/social/google?rkey=${this.$route.query.rkey}&checkout=true`, { token, coursePurchase: this.$route.query.ptype === 'individual-course' });
        if (request && request.businessAccount) {
          this.$store.dispatch('auth/setUserInfo', request);
        }
        if (request && request.user) {
          if (request.user.registered) {
            this.$tracking.setSignupEvent({ signupType: 'Google', directSend: true, userId: request.user.id });
          }

          this.$store.dispatch('auth/setUserInfo', request.user);
          this.$emit('login');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.invisible {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

div {
  position: relative;
  width: 100%;

  ::v-deep iframe {
    max-width: 100% !important;
    max-height: 100% !important;
    margin: 0 !important;
    min-height: 52px !important;
  }

  a {
    border-radius: 0;
    text-align: center;
    transition: none;
    width: 100%;
    display: flex;
    align-items: center;
    line-height: 100%;
    color: var(--main-light);
    padding: var(--spacing-14);
    justify-content: center;

    &.fake.visible {
      position: relative;
      z-index: 1;
    }

    &:not(.visible) {
      visibility: hidden;
      opacity: 0.01;
      top: 0;
      right: 0;
      position: absolute;
      z-index: -1;
    }

    svg {
      vertical-align: sub;
      margin-right: var(--spacing-16);
    }
  }
}
</style>
